module.exports = __webpack_public_path__ + "media/images/covid/icons/distance-fad254804b378bd090a064d64240dc17.png";